import { render, staticRenderFns } from "./Holter.vue?vue&type=template&id=4642fb13&scoped=true"
import script from "./Holter.vue?vue&type=script&lang=js"
export * from "./Holter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642fb13",
  null
  
)

export default component.exports